export default __webpack_public_path__ + "static/media/people.aadeb62f.svg";